import { render } from "./PdfPane.vue?vue&type=template&id=3e6a4720&scoped=true"
import script from "./PdfPane.vue?vue&type=script&lang=js"
export * from "./PdfPane.vue?vue&type=script&lang=js"

import "./PdfPane.vue?vue&type=style&index=0&id=3e6a4720&scoped=true&lang=css"

import exportComponent from "/Users/tomoiida/Dropbox/LegalNetwork/limar/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6a4720"]])

export default __exports__